import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, FormControlLabel, Switch } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import FormulaField from 'features/common/components/formula-field';
import { FormulaFieldLabel, FormulaFieldContainer } from 'components/common/Styles';

export const CompetenceOrderGeneralDataComponent = ({
  competenceOrder,
  approvalTypes,
  applicationStatuses,
  onPropertyChanged,
  validation
}) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          labelKey='approvalTypeName'
          valueKey='approvalTypeId'
          value={{
            approvalTypeId: competenceOrder.approvalTypeId,
            approvalTypeName: competenceOrder.approvalTypeName
          }}
          isClearable={false}
          id='approvalType'
          options={approvalTypes}
          label={t('CompetenceOrder.ApprovalTypeName')}
          onChange={event => {
            onPropertyChanged('approvalTypeId', event ? event.approvalTypeId : null);
            onPropertyChanged('approvalTypeName', event ? event.approvalTypeName : null);
          }}
          error={!isValid(validation.approvalTypeId)}
          helperText={getErrors(validation.approvalTypeId)}
          required
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          fullWidth
          labelKey='statusName'
          valueKey='statusId'
          value={competenceOrder.appStatusId}
          simpleValue
          isClearable={false}
          isSearchable={true}
          options={applicationStatuses}
          id='appStatus'
          label={t('CompetenceOrder.StatusName')}
          onChange={event => onPropertyChanged('appStatusId', event)}
          error={!isValid(validation.appStatusId)}
          helperText={getErrors(validation.appStatusId)}
          required
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <FormControlLabel
          control={<Switch checked={competenceOrder.stopAfterFirstTrueRuleYN || false} />}
          label={t('CompetenceOrder.StopAfterFirstTrueRuleYN')}
          onChange={event => onPropertyChanged('stopAfterFirstTrueRuleYN', event.target.checked)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField fullWidth value={competenceOrder.documentTypeCode || ''} label={t('CompetenceOrder.DocumentTypeCode')} disabled={true} />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          value={competenceOrder.docStructureKey}
          onChange={event => onPropertyChanged('docStructureKey', event)}
          label={t('CompetenceOrder.DocStructureKey')}
          error={!isValid(validation.docStructureKey)}
          helperText={getErrors(validation.docStructureKey)}
          required
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormulaFieldLabel error={!isValid(validation.expression)} required>
          {t('LeasingExpenseType.Formula')}
        </FormulaFieldLabel>
        <FormulaFieldContainer>
          <FormulaField
            formulaLabel={t('CompetenceOrder.Expression')}
            value={competenceOrder.expression}
            onChange={event => onPropertyChanged('expression', event)}
          />
        </FormulaFieldContainer>
      </Grid>
    </Grid>
  );
};

CompetenceOrderGeneralDataComponent.propTypes = {
  approvalTypes: PropTypes.array.isRequired,
  applicationStatuses: PropTypes.array.isRequired,
  competenceOrder: PropTypes.object.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default CompetenceOrderGeneralDataComponent;
